import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=c9f0ee80&lang=pug&"
import script from "./admin.vue?vue&type=script&lang=js&"
export * from "./admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9f0ee80')) {
      api.createRecord('c9f0ee80', component.options)
    } else {
      api.reload('c9f0ee80', component.options)
    }
    module.hot.accept("./admin.vue?vue&type=template&id=c9f0ee80&lang=pug&", function () {
      api.rerender('c9f0ee80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/admin.vue"
export default component.exports